import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import GroupFeed from '../components/groups/GroupFeed';
import GroupMembers from '../components/groups/GroupMembers';
import AlgaWeeklySummaryWidget from '../components/groups/AlgaWeeklySummaryWidget';
import { UsersIcon, MessageSquareIcon, TrendingUpIcon, XIcon } from 'lucide-react';
// Group data based on groupId
const groupsData: Record<string, any> = {
  '1': {
    id: 1,
    name: 'Zero Sprechi (Italia)',
    description: 'Consigli pratici per ridurre sprechi e rifiuti ogni giorno.',
    image: 'https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=800&q=80',
    members: 2348,
    posts: 156,
    activeMembers: 89
  },
  '2': {
    id: 2,
    name: 'Mobilità Smart & Bici',
    description: 'Percorsi, sicurezza e idee per muoversi meglio in città.',
    image: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=800&q=80',
    members: 1126,
    posts: 98,
    activeMembers: 57
  },
  '3': {
    id: 3,
    name: 'Green Food & Spesa Consapevole',
    description: "Ricette semplici, stagionalità e scelte d'acquisto più sostenibili.",
    image: 'https://images.unsplash.com/photo-1488459716781-31db52582fe9?w=800&q=80',
    members: 3041,
    posts: 212,
    activeMembers: 104
  }
};
const GroupDetailPage = () => {
  const [activeTab, setActiveTab] = useState('feed');
  const {
    groupId
  } = useParams();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Get group data or fallback to group 1
  const groupData = groupsData[groupId || '1'] || groupsData['1'];
  const renderContent = () => {
    switch (activeTab) {
      case 'feed':
        return <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2487">
            <div className="lg:col-span-2" data-id="element-2488">
              <GroupFeed groupId={groupId} data-id="element-2489" />
            </div>
            <div className="lg:col-span-1" data-id="element-2490">
              <AlgaWeeklySummaryWidget groupId={groupId} data-id="element-2491" />
            </div>
          </div>;
      case 'members':
        return <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2492">
            <div className="lg:col-span-2" data-id="element-2493">
              <GroupMembers groupId={groupId} data-id="element-2494" />
            </div>
            <div className="lg:col-span-1" data-id="element-2495">
              <AlgaWeeklySummaryWidget groupId={groupId} data-id="element-2496" />
            </div>
          </div>;
      default:
        return <GroupFeed groupId={groupId} data-id="element-2497" />;
    }
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-2498">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-2499">
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-2500"></div>
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black" data-id="element-2501">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-2502">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-2503">
              <span className="sr-only" data-id="element-2504">Close sidebar</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-2505" />
            </button>
          </div>
          <div className="flex-1 h-full overflow-y-auto" data-id="element-2506">
            <Sidebar activePage="community" data-id="element-2507" />
          </div>
        </div>
      </div>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-2508">
        <Sidebar activePage="community" data-id="element-2509" />
      </div>

      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-2510">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-2511" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 pt-0 md:pt-0 bg-gray-50" data-id="element-2512">
          <div className="max-w-7xl mx-auto pt-4 md:pt-6" data-id="element-2513">
            {/* Group Header */}
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm mb-6 overflow-hidden" data-id="element-2514">
              {/* Cover Image */}
              <div className="h-48 overflow-hidden" data-id="element-2515">
                <img src={groupData.image} alt={groupData.name} className="w-full h-full object-cover" data-id="element-2516" />
              </div>

              <div className="p-6" data-id="element-2517">
                <h1 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-2518">
                  {groupData.name}
                </h1>
                <p className="text-gray-600 mb-4 font-normal" data-id="element-2519">
                  {groupData.description}
                </p>
                <div className="flex flex-wrap items-center gap-4 sm:gap-6" data-id="element-2520">
                  <div className="flex items-center text-gray-500" data-id="element-2521">
                    <UsersIcon size={16} className="mr-1.5" strokeWidth={1.5} data-id="element-2522" />
                    <span className="text-sm font-normal" data-id="element-2523">
                      {groupData.members.toLocaleString('it-IT')} membri
                    </span>
                  </div>
                  <div className="flex items-center text-gray-500" data-id="element-2524">
                    <MessageSquareIcon size={16} className="mr-1.5" strokeWidth={1.5} data-id="element-2525" />
                    <span className="text-sm font-normal" data-id="element-2526">
                      {groupData.posts} post
                    </span>
                  </div>
                  <div className="flex items-center text-gray-500" data-id="element-2527">
                    <TrendingUpIcon size={16} className="mr-1.5" strokeWidth={1.5} data-id="element-2528" />
                    <span className="text-sm font-normal" data-id="element-2529">
                      {groupData.activeMembers} attivi
                    </span>
                  </div>
                </div>
              </div>

              {/* Tab Navigation */}
              <div className="border-t border-gray-200 px-6 overflow-x-auto" data-id="element-2530">
                <nav className="flex space-x-8" data-id="element-2531">
                  <button onClick={() => setActiveTab('feed')} className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${activeTab === 'feed' ? 'border-green-600 text-green-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-2532">
                    Feed
                  </button>
                  <button onClick={() => setActiveTab('members')} className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${activeTab === 'members' ? 'border-green-600 text-green-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-2533">
                    Membri
                  </button>
                </nav>
              </div>
            </div>

            {/* Content area */}
            {renderContent()}
          </div>
        </main>
      </div>
    </div>;
};
export default GroupDetailPage;